import { Component, Input, OnInit } from '@angular/core';
import { ROLES_KEYS, User } from '@interfaces';

@Component({
  selector: 'app-cr-employee-role-tag',
  templateUrl: './cr-employee-role-tag.component.html',
  styleUrls: ['./cr-employee-role-tag.component.scss'],
  standalone: false,
})
export class CrEmployeeRoleTagComponent {
  public readonly COLOR_BY_ROLE: { [key: string]: string } = {
    [ROLES_KEYS.Team_Leader]: 'blue',
    [ROLES_KEYS.Employee]: 'green',
    [ROLES_KEYS.Field_Consultant]: 'purple',
  };

  @Input() roleKey: ROLES_KEYS | string;

  constructor() {}
}
